import { StatusEnum, CommentTypeEnum } from "@/api/lctApISchemas";

export const ApplicationStatus: { [K in StatusEnum]: K } = {
  STARTED: "STARTED",
  PART_1_SUBMITTED: "PART_1_SUBMITTED",
  PART_1_APPROVED: "PART_1_APPROVED",
  PART_2_SUBMITTED: "PART_2_SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FURTHER_INFO_PART_1: "FURTHER_INFO_PART_1",
  FURTHER_INFO_PART_2: "FURTHER_INFO_PART_2",
};

export const statusDetails = new Map<StatusEnum, { buttonText: string; nextStatus: keyof typeof ApplicationStatus }>([
  [ApplicationStatus.STARTED, { buttonText: "Submit Part 1", nextStatus: ApplicationStatus.PART_1_SUBMITTED }],
  [ApplicationStatus.PART_1_SUBMITTED, { buttonText: "Part 1 Submitted", nextStatus: ApplicationStatus.PART_1_SUBMITTED }],
  [ApplicationStatus.PART_1_APPROVED, { buttonText: "Submit Part 2", nextStatus: ApplicationStatus.PART_2_SUBMITTED }],
  [ApplicationStatus.PART_2_SUBMITTED, { buttonText: "Application Submitted", nextStatus: ApplicationStatus.PART_2_SUBMITTED }],
  [ApplicationStatus.APPROVED, { buttonText: "Finished", nextStatus: ApplicationStatus.APPROVED }],
  [ApplicationStatus.REJECTED, { buttonText: "Finished", nextStatus: ApplicationStatus.REJECTED }],
  [ApplicationStatus.FURTHER_INFO_PART_1, { buttonText: "Resubmit Part 1", nextStatus: ApplicationStatus.PART_1_SUBMITTED }],
  [ApplicationStatus.FURTHER_INFO_PART_2, { buttonText: "Resubmit Application", nextStatus: ApplicationStatus.PART_2_SUBMITTED }],
]);

export type StatusOption = { label: string; value: StatusEnum };

export const statusOptions: StatusOption[] = [
  { label: "In Progress", value: ApplicationStatus.STARTED },
  { label: "Awaiting review (Part 1)", value: ApplicationStatus.PART_1_SUBMITTED },
  { label: "Part 1 Approved", value: ApplicationStatus.PART_1_APPROVED },
  { label: "Awaiting review (Part 2)", value: ApplicationStatus.PART_2_SUBMITTED },
  { label: "Approved", value: ApplicationStatus.APPROVED },
  { label: "Rejected", value: ApplicationStatus.REJECTED },
  { label: "Updates required (Part 1)", value: ApplicationStatus.FURTHER_INFO_PART_1 },
  { label: "Updates required (Part 2)", value: ApplicationStatus.FURTHER_INFO_PART_2 },
];

export const defaultStatus = { buttonText: "View", nextStatus: ApplicationStatus.STARTED };

export const CommentType: { [K in CommentTypeEnum]: K } = {
  CARBON_SCORE: "CARBON_SCORE",
  FEEDBACK: "FEEDBACK",
};

export const CountryCodes = {
  US: "US",
  UK: "UK",
  AU: "AU",
};

export const TABLE_IDS = {
  USER_APPLICATIONS_ADMIN: "user-applications-admin",
  USER_APPLICATIONS_USER: "user-applications-user",
  USERS: "users",
};
